/** @jsx jsx */
import { Dialog } from '@datacamp/waffles/dialog';
import { FormField } from '@datacamp/waffles/form-field';
import { Select } from '@datacamp/waffles/select';
import { TextArea } from '@datacamp/waffles/text-area';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import { TFunction } from 'i18next';
import React from 'react';
import { withTranslation } from 'react-i18next';

type Props = {
  categories?: Array<{
    key: string;
    value: string;
  }>;
  modalTitle: string;
  onClose: (...args: any[]) => any;
  onSubmit: (...args: any[]) => any;
  optional?: boolean;
  submitRequestState?: string;
  t: TFunction;
};

type State = any;

class ReporterForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedCategory: '',
      userFeedback: '',
    };
    this.submit = this.submit.bind(this);
    this.updateCategory = this.updateCategory.bind(this);
    this.updateFeedback = this.updateFeedback.bind(this);
  }

  submit(event: any): void {
    event.preventDefault();
    this.props.onSubmit({
      category: this.state.selectedCategory,
      userFeedback: this.state.userFeedback,
    });
  }

  updateCategory(value: any): void {
    this.setState({ selectedCategory: value });
  }

  updateFeedback(text: string): void {
    this.setState({ userFeedback: text });
  }

  render(): React.ReactNode {
    const {
      categories,
      modalTitle,
      optional = false,
      submitRequestState,
      t,
    } = this.props;
    const submitDisabled =
      submitRequestState !== 'none' ||
      this.state.userFeedback === '' ||
      (categories && this.state.selectedCategory === '');

    return (
      <>
        <Dialog.Header>{modalTitle}</Dialog.Header>
        <form name="reportForm" id="report-form" onSubmit={this.submit}>
          <Dialog.Body>
            <div
              css={{
                display: 'flex',
                flexDirection: 'column',
                gap: tokens.spacing.medium,
              }}
            >
              {categories && (
                <FormField
                  label={t('ReporterForm.feedbackType')}
                  required={!optional}
                >
                  <Select
                    data-cy="report-select"
                    name="test"
                    value={this.state.selectedCategory}
                    onChange={(event) =>
                      this.updateCategory(event.target.value)
                    }
                  >
                    <option value="" disabled>
                      {t('ReporterForm.feedbackTypePlaceholder')}
                    </option>
                    {categories.map((category) => {
                      const { key, value } = category;
                      return <option key={key}>{value}</option>;
                    })}
                  </Select>
                </FormField>
              )}
              <FormField
                label={t('ReporterForm.feedbackMessage')}
                required={!optional}
              >
                <TextArea
                  data-cy="report-content"
                  name="extra"
                  onChange={(event) => this.updateFeedback(event.target.value)}
                  value={this.state.userFeedback}
                  showCharacterCount
                  rows={8}
                  maxLength={1000}
                />
              </FormField>
            </div>
          </Dialog.Body>
          <Dialog.Footer>
            <Dialog.Button
              variant="secondary"
              data-cy="modal-close"
              onClick={this.props.onClose}
            >
              {t('ReporterForm.secondaryButton')}
            </Dialog.Button>
            <Dialog.Button
              data-cy="report-submit"
              type="submit"
              disabled={submitDisabled}
              variant="primary"
            >
              {t('ReporterForm.primaryButton')}
            </Dialog.Button>
          </Dialog.Footer>
        </form>
      </>
    );
  }
}

export default withTranslation()(ReporterForm);
